import i18n from '@/i18n';
import { apiAdminCaller } from '@/redux/query/admin';
import { Banner, BlockStack } from '@shopify/polaris';
import parse from 'html-react-parser';
import { useEffect, useState } from 'react';

function setSessionBoolean(key: string, value: boolean) {
  if (typeof value !== 'boolean') {
    throw new Error('Value must be boolean');
  }

  sessionStorage.setItem(key, value ? '1' : '0');
}

function getSessionBoolean(key: string) {
  const value = sessionStorage.getItem(key);

  if (value === null) return false;

  return value === '1';
}

export default function HolidayBanner() {
  const [isHide, setIsHide] = useState<{ [key: string]: boolean }>({});
  const { data } = apiAdminCaller.useGetHolidayBannerQuery({
    languageCode: i18n.language,
  });

  useEffect(() => {
    if (data?.data) {
      const result: { [key: string]: boolean } = {};
      data?.data.forEach((banner) => {
        result[banner.bannerKey] = getSessionBoolean(banner.bannerKey);
      });
      setIsHide(result);
    }
  }, [data?.data]);

  return (
    <div className="d-flex flex-column gap-16 mt-16">
      {data?.data?.map((banner, index) => {
        return (
          <BlockStack key={index}>
            {banner?.bannerTranslations.map(
              (content: { title: string; description: string[] }) =>
                !isHide[banner.bannerKey] && (
                  <Banner
                    key={banner?.id}
                    title={content?.title}
                    tone={banner?.tone}
                    onDismiss={() => {
                      setSessionBoolean(banner.bannerKey, true);
                      setIsHide({
                        ...isHide,
                        [banner.bannerKey]: true,
                      });
                    }}
                  >
                    {parse(content?.description.join(' ') || '')}
                  </Banner>
                ),
            )}
          </BlockStack>
        );
      })}
    </div>
  );
}
